import { Component, OnInit } from '@angular/core';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { PopoverRef } from 'src/@vex/components/popover/popover-ref';
import { IExam } from 'src/app/interface/dto';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
@Component({
  selector: 'app-pause-unpause-exam',
  templateUrl: './pause-unpause-exam.component.html',
  styleUrls: ['./pause-unpause-exam.component.scss']
})
export class PauseUnpauseExamComponent implements OnInit {
  exam: IExam = examDefault;
  reason: any;

  constructor(private popoverRef: PopoverRef<PauseUnpauseExamComponent>,
    private examService: ExamService, private snackBar: SnackbarService,) { }

  ngOnInit() {
    if (this.examService.selectedExams?.length === 1) {
      this.exam = this.examService.selectedExams[0];
    }
  }
  close() {
    this.popoverRef.close();
  }

  ChangePauseStatus() {
    let data = { "ExaminationIDs": this.examService.selectedExamIds, "Reason": this.reason, "SelectAllExam": this.examService.selectAll };
    if (this.examService.selectedExams?.length >= 1) {
      this.examService.pauseUnpauseExam(data).then((res: any) => {
        this.snackBar.success('Exam status updated successfully');
        this.popoverRef.close();
      })
        .catch((err: any) => {
          this.snackBar.error('Failed to change exam status. Please try again later.');
          console.error(err);
        });
    } else {
      this.snackBar.error('Please select at least one exam to change status.');
    }
  }
}
